import request from '@/utils/request'

// 用户验证码登录
export function PostLogin(data) {
  return request({
    url: '/wallet-user/login',
    method: 'post',
    data
  })
}

// 用户密码登录
export function PostLoginPassword(data) {
  return request({
    url: '/wallet-user/login-password',
    method: 'post',
    data
  })
}

// 重置密码
export function PostResetPassword(data) {
  return request({
    url: '/wallet-user/reset-password',
    method: 'post',
    data
  })
}

// 登录获取验证码
export function PostSendOpt(data) {
  return request({
    url: '/wallet-user/send-opt',
    method: 'post',
    data
  })
}

// 重置密码获取验证码
export function PostSendResetPasswordOpt(data) {
  return request({
    url: '/wallet-user/send-opt-reset-password',
    method: 'post',
    data
  })
}

// 获取用户基础信息
export function PostGetWalletUserBaseInfo(data) {
  return request({
    url: '/walletUserInfo/getWalletUserBaseInfo',
    method: 'post',
    data
  })
}

export function GetCashOutOpt(params) {
  return request({
    url: '/walletUserWithdraw/sendOpt',
    method: 'get',
    params
  })
}

export function GetTopUpMobileOpt(params) {
  return request({
    url: '/walletUserTopUp/sendOpt',
    method: 'get',
    params
  })
}

export function GetLastBalance(data) {
  return request({
    url: '/walletUserBalance/getLastBalance',
    method: 'post',
    data
  })
}

// jt商户准入详情
export function PostThirdPartyAdmissionJT(data) {
  return request({
    url: '/jt/thirdPartyAdmission/detail',
    method: 'post',
    data
  })
}

// jt用户验证码登录
export function PostLoginJT(data) {
  return request({
    url: '/jt/thirdPartyAdmission/verifyMobile',
    method: 'post',
    data
  })
}

// jt商户登录获取验证码
export function PostSendOptJT(data) {
  return request({
    url: '/jt/thirdPartyAdmission/getVerifyCode',
    method: 'post',
    data
  })
}
// jt获取代扣方式
export function getUserPaymentMethod(params) {
  return request({
    url: '/walletUserDirectDebitAuth/getUserPaymentMethod',
    method: 'get',
    params
  })
}
// jt同意开通代扣
export function ActivateDirectDebit(data) {
  return request({
    url: '/jt/thirdPartyAdmission/activateDirectDebit',
    method: 'post',
    data
  })
}
// 获取所有 JT VIP 商户名称列表接口
export function GetJtVipMerchants(params) {
  return request({
    url: '/jt/thirdPartyAdmission/getJtVipMerchants',
    method: 'get',
    params
  })
}

// 企业身份钱包用户 Basic KYC 详情接口
export function EnterpriseUserBasicKycDetail(data) {
  return request({
    url: '/walletUserInfo/enterpriseUser/basicKyc/detail',
    method: 'post',
    data
  })
}

export function PostLogout(data) {
  return request({
    url: '/wallet-user/logout',
    method: 'post',
    data
  })
}
